import { Link } from "@tanstack/react-router";

import * as m from "@/paraglide/messages";

export function CtaBanner() {
	return (
		<section className="px-4 pb-12 md:px-12">
			<div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-6 rounded-[40px] bg-secondary px-6 py-6 md:flex-row md:gap-[30px] md:px-[30px] md:py-4">
				<GeeseMark />
				<p className="flex-1 text-2xl font-semibold leading-none text-[#272727] md:text-2xl">
					{m.landing_cta_text()}
				</p>
				<Link
					to="/sign-up"
					className="inline-flex shrink-0 items-center rounded-[36px] bg-primary px-6 py-3 text-base font-bold text-primary-foreground transition-shadow hover:shadow-lg"
				>
					{m.landing_cta_button()}
				</Link>
			</div>
		</section>
	);
}

function GeeseMark() {
	return (
		<div className="relative h-[168px] w-[172px] shrink-0 overflow-hidden">
			<div className="absolute left-0 top-0 h-[158px] w-[160px] rounded-full bg-[#fdda6d]" />
			<div className="absolute left-[6px] top-[21px] flex items-center gap-3">
				<img
					src="/images/goose-small.svg"
					alt=""
					aria-hidden="true"
					className="h-[101px] w-[54px]"
				/>
				<img
					src="/images/goose-large.svg"
					alt=""
					aria-hidden="true"
					className="h-[147px] w-[79px]"
				/>
			</div>
		</div>
	);
}
